import { MarkerClusterer, GridAlgorithm } from "@googlemaps/markerclusterer";
export default {
    data() {
        return {
            days: [
                "sunday",
                "monday",
                "tuesday",
                "wednesday",
                "thursday",
                "friday",
                "saturday",
            ],
            bounds: null,
            currentMarker: null,
            isLocation: false,
            refuseGeolocation: false,
            cluster: [],
            markerClusterer: null,
            top2Markers: null,
        }
    },
    computed: {
        current() {
            let today = new Date();
            return this.days[today.getDay()];
        },
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
    },
    methods: {
       
        loadGoogleMapsAPI() {
            return new Promise((resolve, reject) => {
                if (typeof google !== "undefined") {
                    resolve();
                    return;
                }
                const script = document.createElement("script");
                script.src = `https://maps.google.com/maps/api/js?key=AIzaSyB-5IUvwtncbrYVKOALxInF91-amipA_YU&libraries=geometry,places,marker&`;
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    resolve();
                };
                script.onerror = (error) => reject(error);

                document.head.appendChild(script);
            });
        },
        loadinitialMarkers() {
            this.markers.forEach((markerData, index) => {
                
                const markerElement = document.createElement('div');
                markerElement.className = 'GoogleMapPin';
                markerElement.innerHTML = `
                    <div class="inner" role="button" tabindex="0">
                    <div class="index">${index + 1}</div>
                    </div>
                `;
                
                const marker = new google.maps.marker.AdvancedMarkerElement({
                    position: markerData.geolocalization,
                    map: this.map,
                    title: markerData.name,
                    content: markerElement,
                    gmpClickable: true,
                    collisionBehavior: 'REQUIRED_AND_HIDES_OPTIONAL'
                });
                marker.customData = {
                    title: markerData.name,
                    address: markerData.address,
                    phone: markerData.phone,
                    activities: markerData.activities,
                    location: markerData.geolocalization,
                    website: markerData.website,
                    schedules: markerData.schedules, 
                    visible: true,
                    image: markerData.image,
                    email: markerData.email_contact,
                    index: index + 1
                }
                marker.addListener('click', ()=> {
                    this.markerDetail([marker, marker.customData],index)
                })
                this.filteredMarkers.push([marker, marker.customData]);
                this.cluster.push(marker)
                
            });
            let renderer = {
                render({ count, position }, stats) {
                    const color = "#OOOOOO";
                    const svg = window.btoa(`
                    <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                        <circle cx="120" cy="120" opacity="1" r="70" />
                    </svg>`);
                    return new google.maps.Marker({
                        position,
                        icon: {
                            url: `data:image/svg+xml;base64,${svg}`,
                            scaledSize: new google.maps.Size(90, 90),
                        },
                        label: {
                            text: String(count),
                            color: "#FFF",
                            fontSize: "16px",
                            fontWeight: "600"
                        },
                        zIndex:
                            count === 0
                                ? 0
                                : Number(google.maps.Marker.MAX_ZINDEX) + count,
                    });
                },
            };
            this.markerClusterer = new MarkerClusterer( {
                map: this.map, 
                renderer: renderer,
                algorithm: new GridAlgorithm({
                    gridSize: 60
                })
            });

            this.markerClusterer.addMarkers(this.cluster)
        },
        // initialisation de la map 
        initMap() {
            this.map = new google.maps.Map(document.getElementById("map"), {
                center:window.innerWidth > 1024 ?  { lat: 48, lng: -6.2 } : { lat: 48.8566, lng: 2.3522 },
                zoom:  window.innerWidth > 1024 ? 6 : 4,
                mapTypeControl: false,
                fullscreenControl: false,
                streetViewControl: false,
                zoomControl: true,
                panControl: false,
                scaleControl: false,
                rotateControl: false,
                mapId: "DEMO_MAP_ID",
            });
            this.infoWindow = new google.maps.InfoWindow();
            const input = document.getElementById("autocomplete");
            this.autocomplete = new google.maps.places.Autocomplete(input);
            // {componentRestrictions: { country: 'FR' },}
            this.bounds = new google.maps.LatLngBounds();

            this.autocomplete.addListener("place_changed", this.onPlaceChanged);
            google.maps.event.addListener(this.map, "bounds_changed", this.updateVisibleMarkers);
            
            this.placeService = new google.maps.places.PlacesService(this.map);
            this.loadinitialMarkers()

        },

        // au clique si geolocation activé center la map sur sa position
        getUserLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const userPos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };
                        this.map.setCenter(userPos);
                        this.map.setZoom(14);
                        const geocoder = new google.maps.Geocoder();
                        geocoder.geocode( { location: userPos },
                        (results, status) => {
                            if (status === 'OK' && results[0]) {
                            const test = document.getElementById("autocomplete");
                            test.value = results[0].formatted_address;
                            if (this.autocomplete) {
                                const place = {
                                    geometry: { location: userPos },
                                    formatted_address: results[0].formatted_address,
                                };
                                this.isLocation = true
                                this.onPlaceChanged(place);
                            } else {
                            console.error("Autocomplete n'est pas initialisé.");
                            }

                            } else {
                            console.error('Impossible de trouver l’adresse.');
                            }
                        }
                        );
                    },
                    () => {
                        this.handleLocationError();
                    }
                );
            } else {
                this.handleLocationError();
            }
        },

        // si la geolocation est refusé ou impossible
        handleLocationError() {
            this.refuseGeolocation = true
        },

        // trigger la selection de la recherche
        onPlaceChanged( params) {
            if(params) {
                this.place = params
            }
            else {
                this.place =  this.autocomplete.getPlace()
                this.isLocation = false
            }
            if (!this.place.geometry) {
                return;
            }
            this.closeDetail()
            this.inputValue = this.place.formatted_address;
            if(this.currentMarker) this.currentMarker.setMap(null)
                
            const markerElement = document.createElement('div');
            markerElement.className = 'GoogleMapPin';
            markerElement.innerHTML = `
                <svg class="icon icon-pin-current">
                    <use xlink:href="#icon-pin-current"></use>
                </svg>
            `;
            this.currentMarker = new google.maps.marker.AdvancedMarkerElement({
                position: this.place.geometry.location,
                map: this.map,
                gmpClickable: true,
                content: markerElement,
                collisionBehavior: 'REQUIRED_AND_HIDES_OPTIONAL'
            });
            this.bounds = new google.maps.LatLngBounds();
            this.filteredMarkers.forEach((marker, index) => {
                const distance = this.calculateDistance(this.place.geometry.location, { lat: marker[1].location.lat, lng: marker[1].location.lng }, this.isLocation);
                marker[1].distance = distance.toFixed(0)
            })
            this.filterResult();
            
        },

        closeSearch() {
            this.inputValue = null
            this.top2Markers = this.filteredMarkers.slice(0, 2);
            // this.filteredMarkers.sort((a, b) => a[1].distance - b[1].distance);
            this.markerClusterer.clearMarkers();
            this.top2Markers.forEach(element => {
                element[0].map = null
                element[1].visible = false
            });
            this.clearMarkers();
            this.loadinitialMarkers()
            this.currentMarker = null
            this.place = null
            this.isLocation = false
            this.map.setCenter(window.innerWidth > 1024 ?  { lat: 48, lng: -6.2 } : { lat: 48.8566, lng: 2.3522 })
            this.map.setZoom(window.innerWidth > 1024 ? 6 : 4)
        },

        // Filtrer et trier les markers en fonction de la recherche
        filterResult() {
            let clust = []
            this.markerClusterer.clearMarkers();
            this.filteredMarkers = this.filteredMarkers.slice().map(marker => {
                const distance = this.calculateDistance(this.place.geometry.location, { lat: marker[1].location.lat, lng: marker[1].location.lng }, this.isLocation);
                return { ...marker, distance }; 
            }).sort((a, b) => a.distance - b.distance); 
            this.top2Markers = this.filteredMarkers.slice(0, 2);
            
            // this.filteredMarkers.sort((a, b) => a[1].distance - b[1].distance);

            this.filteredMarkers.forEach((element, index) => {
                element[0].map = this.map
                element[1].visible = true
                const markerElement = document.createElement('div');
                markerElement.className = 'GoogleMapPin';
                markerElement.innerHTML = `
                    <div class="inner" role="button" tabindex="0">
                    <div class="index">${index + 1}</div>
                    </div>
                `;
                element[0].content = markerElement
                element[1].index = index + 1
                element[1].visible = true
            });
            this.top2Markers.forEach((element, index) => {
                element[0].map = this.map
                element[1].visible = true
                clust.push(element[0])
                const markerElement = document.createElement('div');
                markerElement.className = 'GoogleMapPin';
                markerElement.innerHTML = `
                    <div class="inner" role="button" tabindex="0">
                    <div class="index">${index + 1}</div>
                    </div>
                `;
                element[0].content = markerElement
                element[1].index = index + 1
                element[1].visible = true
               
                this.bounds.extend(element[1].location);
                this.bounds.extend(this.place.geometry.location);
            });
            this.markerClusterer.addMarkers(clust);
            if(!this.isMobile) {
                const paddingOptions = {
                    top: 80,   
                    right: 80, 
                    bottom: 80, 
                    left: 723   
                };
                this.map.fitBounds(this.bounds, paddingOptions );
            }
            else {
                this.map.fitBounds(this.bounds );
            }
        },

        // Calculer la distance entre le point recherché et chaque markers
        calculateDistance(location1, location2, params) {
            let lat = null;
            let lng = null;

            if(params) {
                lat = location1.lat;
                lng = location1.lng;
            }
            else {
                lat = location1.lat();
                lng = location1.lng();
            }
            const R = 6371; 
            const dLat = this.deg2rad(location2.lat - lat);
            const dLng = this.deg2rad(location2.lng - lng);
            const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(this.deg2rad(lat)) * Math.cos(this.deg2rad(location2.lat)) *
                        Math.sin(dLng / 2) * Math.sin(dLng / 2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return R * c; 
        },
        deg2rad(deg) {
            return deg * (Math.PI / 180);
        },

        //supprimé tous les markers sur la map
        clearMarkers() {
            if(this.currentMarker) this.currentMarker.setMap(null)
            this.filteredMarkers.forEach((marker) => marker[0].setMap(null));
            this.filteredMarkers = [];
            this.cluster = [];
        },

        markerDetail(marker,keySelected) {
            this.showDetail = true
            this.markerSelect = marker
        
            this.map.setZoom(14);
            this.map.panTo(marker[1].location);
            if(!this.isMobile) {
                this.map.panBy(-200, 0)
            }
            
            document.querySelectorAll('.GoogleMapPin').forEach(element => {
                element.classList.remove('active')
                element.classList.remove('current')
            });

            let selected =  marker[0].element.querySelector('.GoogleMapPin')
            selected.classList.add('active')
            selected.classList.add('current')

            this.keySelected = keySelected
        },

        closeDetail() {
            this.showDetail = false
            document.querySelectorAll('.GoogleMapPin').forEach(element => {
                element.classList.remove('active')
                element.classList.remove('current')
            });
            this.markerSelect = null
            this.keySelected = null
            this.filterResult()
        },
        showFilterList() {
            this.filterOpen = true
        },

        // Filtrer les markers en fonction des activités
        validateFilter(value) {
            this.filterOpen = false
            this.selectedActivities = value
            this.markerClusterer.clearMarkers();
            const filtered =  this.filteredMarkers.filter(marker => {
                if (this.selectedActivities.length === 0) return true;

                if(marker[1].visible) {
                    return marker[1].activities.some(activity => this.selectedActivities.includes(activity));
                }
                
            });

           
            this.filteredMarkers.filter(marker => {
                marker[0].map = null
                marker[1].visible = false
            })
            
            filtered.forEach((element, index) => {
                element[0].map = this.map
                element[1].visible = true
                const markerElement = document.createElement('div');
                markerElement.className = 'GoogleMapPin';
                markerElement.innerHTML = `
                    <div class="inner" role="button" tabindex="0">
                    <div class="index">${index + 1}</div>
                    </div>
                `;
                element[0].content = markerElement
                element[1].index = index + 1
            });
        },
        closeFilter() {
            this.filterOpen = false
        },
        resetFilter() {
            this.isReset = true;
            this.selectedActivities = []
            this.filterResult()
           
        },

        isOpenNow(schedules) {
            const now = new Date();
            const currentHour = now.getHours();
            const currentMinutes = now.getMinutes();
            const isWithinTimeSlot = (opening, closing) => {
                if (!opening || !closing) return false;

                const openingTime = opening.hour * 60 + (opening.minutes || 0);
                const closingTime = closing.hour * 60 + (closing.minutes || 0);
                const currentTime = currentHour * 60 + currentMinutes;

                return currentTime >= openingTime && currentTime < closingTime;
            };
            return Object.values(schedules).some(
                (schedule) =>
                    (schedule.morning &&
                        isWithinTimeSlot(
                            schedule.morning.opening_time,
                            schedule.morning.closing_time
                        )) ||
                    (schedule.afternoon &&
                        isWithinTimeSlot(
                            schedule.afternoon.opening_time,
                            schedule.afternoon.closing_time
                        ))
            );
        },

        searchValueNotNull(array) {
            return Object.values(array).some((value) => {
                if (value && typeof value === "object") {
                    return this.searchValueNotNull(value);
                }
                return value !== null;
            });
        },

        updateVisibleMarkers() {
            if (!this.map) return;
            const bounds = this.map.getBounds();
            let visibleMarkers = []
            this.filteredMarkers.forEach(element => {
                element[1].visible = false
            });
            visibleMarkers = this.filteredMarkers.filter(marker =>  bounds.contains(marker[1].location));
            visibleMarkers.forEach(element => {
                element[1].visible = true
            });

          },
    },
}